import { Theme } from '@mui/material';
import { SelectOption } from '../common/SearchableSelect';

/** The status filter both expense lists offer. "Reversed" is approved-then-reversed. */
export const EXPENSE_STATUS_FILTER_OPTIONS: SelectOption[] = [
  { value: '', label: 'All' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'REJECTED', label: 'Rejected' },
  { value: 'REVERSED', label: 'Reversed' },
];

/** The dot colour beside each status option, matching its row chip. */
export const expenseStatusColor = (theme: Theme, status: string): string => {
  switch (status) {
    case 'PENDING': return theme.palette.warning.main;
    case 'APPROVED': return theme.palette.success.main;
    case 'REJECTED': return theme.palette.error.main;
    default: return theme.palette.text.secondary;
  }
};
